import axios from "axios";
import { IDocumentDetail } from "../Interfaces/IDocumentDetail";
import { IDocumentRecord } from "../Interfaces/IDocumentRecord";
import { IWindowData } from "../Interfaces/IWindowData";
import { GLOBALS } from "../Models/Globals";
import { ISrvConnector } from "./ISrvConnector";




export class SrvConnector implements ISrvConnector {

    private _WindowData: IWindowData;

    constructor() {

        this._WindowData = window as any;
        axios.defaults.baseURL = this._WindowData.PublicSec.baseUrl;
        axios.defaults.headers.common["X-WP-Nonce"] = this._WindowData.PublicSec.nonceQuery;
        console.info("Window Data", this._WindowData);

    }

    public async GetDocumentsByTypeYear(idDocumento: number, idIdioma: number, cYear: number): Promise<IDocumentRecord[]> {

        const response = await axios.get(`${GLOBALS.API_URL_BASE_NAME}/docs-year/${idIdioma}/${idDocumento}/${cYear}/1`);
        console.info("Axios Response", response.data);
        return JSON.parse(response.data);

    }

    public async GetDocumentDetails(idDocumento: number): Promise<IDocumentDetail[]> {

        const response = await axios.get(`${GLOBALS.API_URL_BASE_NAME}/docs-detail/${idDocumento}`);
        console.info("Axios Response", response.data);
        return JSON.parse(response.data);

    }


    public get WindowData(): IWindowData {
        return this._WindowData;
    }
    public set WindowData(v: IWindowData) {
        this._WindowData = v;
    }


}